import { PurchaseProductDetails } from '@ancon/wildcat-types'

import { CheckoutRequestedItemDetails } from '../types'
import { UpsellGroupProductWithVariantType } from '../../product/types'

/**
 * Display details for everything the product modal could add to the cart - the
 * chosen variant and every upsell it offers.
 *
 * Only the variant id leaves the client, so this is captured while the product
 * details are still loaded: they are cleared the moment the modal closes, which
 * happens before the add request is made.
 */
export default function getCheckoutRequestedItemDetails(
  productDetails: PurchaseProductDetails,
  selectedVariantId: string | null,
): CheckoutRequestedItemDetails[] {
  const { productId, name, customerFacingName, hasVariants, variants } =
    productDetails

  const details: CheckoutRequestedItemDetails[] = []
  const selectedVariant = variants.find(
    variant => variant.id === selectedVariantId,
  )

  if (selectedVariant) {
    details.push({
      variantId: selectedVariant.id,
      productId,
      name: hasVariants
        ? selectedVariant.customerFacingName || selectedVariant.name
        : customerFacingName || name,
      variantType: selectedVariant.variantType,
    })
  }

  productDetails.upsellGroups.forEach(group => {
    group.products.forEach((product: UpsellGroupProductWithVariantType) => {
      details.push({
        variantId: product.variantId,
        productId: product.productId,
        name: product.hasVariants ? product.variantName : product.productName,
        variantType: product.variantType,
      })
    })
  })

  return details
}
